<template>
<!--访谈主题弹窗-->
    <div class='interviewPopup'>
        <div class='center'>
            <div class='top'>
                <p>{{formart('yyyy年MM月dd日')}}</p>
                <p>{{formart('hh:mm:ss')}}</p>
                <!-- <p style="font-size: 18px; margin-top: 10px">第<span>{{interviewNum}}</span>次访谈</p> -->
            </div>
            <div class="middle">
                <p>访谈主题</p>
                <div style="width:375px;margin:10px auto">
                    <el-input :readonly="isInputReadOnly"   placeholder="请输入本次咨询主题" :value="interviewTheme" v-model="interviewTheme"></el-input>
                </div>
            </div>
        <ul class='bottom'>
            <li  class='navActive_button_noHover' @click="$router.go(-1)">返回</li>
            <li  class='navActive_button' @click="add">开始</li>
        </ul>
        <div class="close" @click="$router.go(-1)">
        </div>
    </div>
    </div>
</template>
<script>
export default {
    name: "interviewPopup",
    props: ['interviewRecord','isInputReadOnly','isParentInterview'],
    components: {
    },
    data() {
        return {
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            category: this.interviewRecord.category,
            interviewTime:this.interviewRecord.interviewTime ,//访谈时间
            interviewNum: this.interviewRecord.interviewNum,//第几次访谈
            interviewTheme:this.interviewRecord.interviewTheme ,//访谈主题
        }
    },
    created() {
        if(this.isParentInterview) {
          this.getParentInterviewNum();
        }else {
          this.getIntervierwNum();
        }


    },
    methods: {
         formart(fmt) { // author: meizz
           // 对Date的扩展，将 Date 转化为指定格式的String
          // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
          // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
          // 例子：
          // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
          // (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
          let date = new Date();
            let o = {
                "M+": date.getMonth() + 1, // 月份
                "d+": date.getDate(), // 日
                "h+": date.getHours(), // 小时
                "m+": date.getMinutes(), // 分
                "s+": date.getSeconds(), // 秒
                "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
                "S": date.getMilliseconds() // 毫秒
            };
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
        },
        // 获取第几次访谈
        getIntervierwNum() {
             let studentId = this.studentId;
                this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.number, {
                    studentId:studentId
                }, {
                    headers: {
                        token: window.sessionStorage.getItem('ymtxToken')
                    }
                }).then((res) => {
                    if(res.data.code==2000){
                        this.interviewNum = res.data.data.num + 1;
                        this.interviewTime = this.formart('yyyy-MM-dd hh:mm:ss')
                    }
                })
        },
      //获取家长第几次访谈
      getParentInterviewNum(){
        let studentId = this.studentId;
        this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.consultationRecord.getParentInterviewNum, {
          studentId: studentId,
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            this.interviewNum = res.data.data.num + 1;
            this.interviewTime = this.formart('yyyy-MM-dd hh:mm:ss')
          }
        })
      },
        add(){
             if(!this.isInputReadOnly&&!this.interviewTheme) {
                 this.$message({
                     message: '请填写访谈主题',
                     type: 'warning'
                 });
                 return;
             }
             this.interviewRecord.category = this.category;
             this.interviewRecord.interviewTime=this.interviewTime;//访谈时间
             this.interviewRecord.interviewNum=this.interviewNum;//第几次访谈
             this.interviewRecord.interviewTheme=this.interviewTheme;//访谈主题
             this.$emit('closePop')
        }
    }
}
</script>

<style scoped lang="less">
.interviewPopup{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.2);
    z-index: 1000;
    .center{
        width: 482px;
        height: 623px;
        position: absolute;
        left: 50%;
        margin-left:-241px;
        top: 50%;
        margin-top: -312px;
        background: url("/imgs/xueyezixun/components/interviewPopup/bg.png") center center;
        .top{
            width: 232px;
            margin: 110px auto 0;
            p{
                text-align: center;
                font-size: 16px;
                &:last-child{
                    letter-spacing: 1.5px;
                    span{
                        font-weight: bolder;
                        color:#22A1EC;
                        margin: 4px;
                        font-size: 18px;
                    }
                }
            }
        }
        .middle{
            p{
                text-align: center;
                font-weight: bolder;
                font-size: 20px;
                color:#0095EB;
                margin-top:130px;
                letter-spacing: 1.5px;
            }
        }
        .bottom{
            width: 288px;
            height: 32px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
            li{
                width: 120px;
                height: 100%;
                border-radius: 16px;
                text-align: center;
                line-height: 32px;
                font-size: 16px;
                cursor: pointer;
                background:#ECF8FE;
                color:#1EA2EE;
                border:1px solid #76C6F4;
                &:hover{
                    background:#099BEF;
                    color:#fff
                }
            }
        }
        .close{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            cursor: pointer;
            position: absolute;
            bottom: 20px;
            left:50%;
            margin-left: -25px;
        }
    }
}
</style>
<style lang="less">
.interviewPopup {
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
}
</style>